import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-invalid-rows',
  templateUrl: './invalid-rows.component.html'
})
export class InvalidRowsComponent {
  @Input() rows: number[];
}
